// eslint-disable-next-line import/no-unresolved
import Worker from '@/worker.js?worker';

import { sendErrorToSentry } from './toast';

let messageId = 1;

const worker = new Worker();

const resolvers = new Map();

worker.onmessage = event => {
	const { id, result, error } = event.data;
	const resolver = resolvers.get(id);

	if (!resolver) {
		return;
	}

	if (error) {
		const resultError = new Error(error.message);
		resultError.stack = error.stack;
		resolver.reject(resultError);
		resolvers.delete(id);
		return;
	}

	resolver.resolve(result);
	resolvers.delete(id);
};

worker.onerror = event => {
	sendErrorToSentry(new Error(event.message));
};

function sendMessage(name, data, transfer) {
	const id = messageId++;
	const { promise, resolve, reject } = Promise.withResolvers();

	resolvers.set(id, {
		resolve,
		reject
	});

	worker.postMessage(
		{
			id,
			name,
			data
		},
		transfer
	);

	return promise;
}

export function decrypt(file, password) {
	return sendMessage(
		'decrypt',
		{
			file,
			password
		},
		[file]
	);
}
